module.exports = __webpack_public_path__ + "img/CAF_B_BLU.db641e06.png";